import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import './TextOverflow.less';

export default class TextOverflow extends PureComponent {
    static propTypes = {
        children: PropTypes.node.isRequired
    };
    render() {
        const { children, ...otherProps } = this.props;
        return (
            <span {...otherProps} className="TextOverflow">{children}</span>
        );
    }
}
